import { HistoryOptions, Options, useQueryState } from 'nuqs';

export function useURLState(
    query: string,
    otpions?: { history?: HistoryOptions }
): [
    string,
    (
        value: string | ((old: string) => string | null) | null,
        options?: Options
    ) => Promise<URLSearchParams>,
] {
    const { history = 'replace' } = otpions || {};
    const [state, setState] = useQueryState(query, {
        defaultValue: '',
        history: history,
    });

    return [state, setState];
}
